export const WHEEL_DEBOUNCE_TIME = 100;
